function getLinkType(link: HTMLAnchorElement): string | undefined {
  const { href, hash } = link;
  if (hash && hash.length > 0) return "anchor";
  if (href?.startsWith("http") && !href.includes(window.location.hostname))
    return "external";
  if (href?.startsWith("http") && href.includes(window.location.hostname))
    return "internal";
  return undefined;
}

export default getLinkType;
